<template>
  <b-progress
    :value="current"
    :max="max"
    :variant="variant ? variant : 'secondary'"
    class="w-100 page-progress"
  />
</template>

<script>
export default {
  name: "PageProgress",
  props: {
    current: {
      type: Number,
      required: true,
    },
    max: {
      type: Number,
      required: true,
    },
    variant: String,
  },
};
</script>

<style scoped lang="scss">
.page-progress {
  position: fixed;
  bottom: 0;
  border-radius: 0 !important;
  height: 10px !important;

  ::v-deep .progress-bar {
    border-radius: 1rem;
  }
}
</style>
